import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';
import LearningTool from './LearningTool';
import PlaybackControl from './PlaybackControl';
import SentenceProgress from './SentenceProgress';

const ControlPanel = observer(() => {
    return (
        <div className="flex w-full flex-col items-center justify-between">
            <div className="w-full pt-5">
                <LearningTool />
            </div>
            <div className="mt-4 w-full">
                <SentenceProgress />
            </div>
            <div
                className={twMerge(
                    'border-base-300 flex items-center justify-center rounded-sm border px-4 shadow-xs',
                    'h-20 w-full',
                )}
            >
                <PlaybackControl />
            </div>
        </div>
    );
});

export default ControlPanel;
